import { range } from "lodash";
import * as React from "react";

interface IPaginationOptions {
  arrowLeft?: (page: number, totalPages: number) => React.ReactNode;
  arrowRight?: (page: number, totalPages: number) => React.ReactNode;
  separator?: React.ReactNode;
  siblings?: number;
  totalPagesLimit?: number;
  page?: (page: number) => React.ReactNode;
  currentPage?: (page: number) => React.ReactNode;
  onClick?(page: number, event: React.MouseEvent<HTMLSpanElement>, context?: string): void; // eslint-disable-line no-restricted-globals
}

const defaultPaginationOptions: IPaginationOptions = {
  arrowLeft: () => "←",
  arrowRight: () => "→",
  page: (page: number) => page,
  currentPage: (page: number) => page,
  separator: "…",
  siblings: 3,
  onClick: () => {},
};

/**
 * Returns array of pagination items
 * (see pagination.spec.ts for examples)
 *
 * @param currentPage number
 * @param totalPages number
 * @param options IPaginationOptions
 *
 */
export function getPagination(
  currentPage: number,
  totalPages: number,
  options?: IPaginationOptions
): React.ReactNode[] {
  const opts = {
    ...defaultPaginationOptions,
    ...options,
  };

  if (totalPages === 1) {
    return [];
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let prefix: any = [];
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let suffix: any = [];

  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  let from = Math.max(currentPage - opts.siblings, 1);
  if (from < 4) {
    from = 1;
  } else {
    // FIXME: Fix this the next time the file is edited.

    // @ts-expect-error TS2722
    // eslint-disable-next-line react/jsx-key
    prefix = [<span onClick={e => opts.onClick(1, e, "firstButton")}>{opts.page(1)}</span>, opts.separator];
  }

  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  let to = Math.min(currentPage + opts.siblings, totalPages);
  if (to > totalPages - 3) {
    to = totalPages;
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  } else if (opts.totalPagesLimit < totalPages) {
    suffix = [opts.separator];
  } else {
    suffix = [
      opts.separator,
      // FIXME: Fix this the next time the file is edited.
      // @ts-expect-error TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      // eslint-disable-next-line react/jsx-key
      <span onClick={e => opts.onClick(totalPages, e, "lastButton")}>{opts.page(totalPages)}</span>,
    ];
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const arrowLeftProps: any = {};
  if (currentPage > 1) {
    // FIXME: Fix this the next time the file is edited.
    // @ts-expect-error TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    arrowLeftProps.onClick = (e: any) => opts.onClick(currentPage - 1, e, "arrowLeftButton");
  }
  // FIXME: Fix this the next time the file is edited.
  // @ts-expect-error TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
  // eslint-disable-next-line react/jsx-key
  const arrowLeft = [<span {...arrowLeftProps}>{opts.arrowLeft(currentPage, totalPages)}</span>];

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const arrowRightProps: any = {};
  if (currentPage < totalPages) {
    // FIXME: Fix this the next time the file is edited.
    // @ts-expect-error TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    arrowRightProps.onClick = (e: any) => opts.onClick(currentPage + 1, e, "arrowRightButton");
  }
  // FIXME: Fix this the next time the file is edited.
  // @ts-expect-error TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
  // eslint-disable-next-line react/jsx-key
  const arrowRight = [<span {...arrowRightProps}>{opts.arrowRight(currentPage, totalPages)}</span>];

  const middle = range(from, to + 1).map(page => {
    if (page === currentPage) {
      // FIXME: Fix this the next time the file is edited.
      // @ts-expect-error TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      // eslint-disable-next-line react/jsx-key
      return <span>{opts.currentPage(page)}</span>;
    }
    // FIXME: Fix this the next time the file is edited.
    // @ts-expect-error TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    // eslint-disable-next-line react/jsx-key
    return <span onClick={e => opts.onClick(page, e, "pageButton")}>{opts.page(page)}</span>;
  });

  return [...arrowLeft, ...prefix, ...middle, ...suffix, ...arrowRight];
}
